export default {"src":"/_next/static/media/Rainbow.29643b53.gif","height":1668,"width":2388,"blurWidth":0,"blurHeight":0};